import createReducer from '../lib/createReducer';
import * as types from '../actions/types';

export const VoiceAIConfig = createReducer({
  voiceaiconfig: {},
  getVoiceStatus: false,
  voiceStatus: false,
  updatingWeavePhone: false,
  updateWeavePhoneSuccess: false,
  updateWeavePhoneFail: false,
}, {
  [types.GET_VOICE_STATUS_START](state, action) {
    const newState = Object.assign({}, state, {
      getVoiceStatus: true,
    });
    return newState;
  },
  [types.GET_VOICE_STATUS_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      getVoiceStatus: false,
      voiceStatus: action.data,
    });
    return newState;
  },
  [types.GET_VOICE_STATUS_FAIL](state, action) {
    const newState = Object.assign({}, state, {
      getVoiceStatus: false,
    });
    return newState;
  },
  [types.UPDATE_VOICE_STATUS_START](state, action) {
    const newState = Object.assign({}, state, {
      getVoiceStatus: true,
    });
    return newState;
  },
  [types.UPDATE_VOICE_STATUS_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      getVoiceStatus: false,
    });
    return newState;
  },
  [types.UPDATE_VOICE_STATUS_FAIL](state, action) {
    const newState = Object.assign({}, state, {
      getVoiceStatus: false,
    });
    return newState;
  },
  [types.UPDATE_WEAVE_PHONE_START](state, action) {
    const newState = Object.assign({}, state, {
      updatingWeavePhone: true,
      updateWeavePhoneSuccess: false,
      updateWeavePhoneFail: false,
    });
    return newState;
  },
  [types.UPDATE_WEAVE_PHONE_SUCCESS](state, action) {
    const newState = Object.assign({}, state, {
      updatingWeavePhone: false,
      updateWeavePhoneSuccess: true,
      updateWeavePhoneFail: false,
    });
    return newState;
  },
  [types.UPDATE_WEAVE_PHONE_FAIL](state, action) {
    const newState = Object.assign({}, state, {
      updatingWeavePhone: false,
      updateWeavePhoneSuccess: false,
      updateWeavePhoneFail: true,
    });
    return newState;
  },
  [types.CLEAR_ERROR_MEESSAGE_VOICE](state, action) {
    const newState = Object.assign({}, state, {
      updatingWeavePhone: false,
      updateWeavePhoneSuccess: false,
      updateWeavePhoneFail: false,
    });
    return newState;
  },
});
export { VoiceAIConfig as default };
